import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatSort} from '@angular/material/sort';
import {PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';
import {KFConfiguration} from '../../../models/kf-configuration.interface';
import {KfConfigurationService} from '../../../services/kf-configuration.service';
import {MatDialog} from '@angular/material/dialog';
import {HelpDialogComponent} from '../../../../shared/components/help-dialog/help-dialog.component';

@Component({
  selector: 'app-kf-configuration-table',
  templateUrl: './kf-configuration-table.component.html',
  styleUrls: ['./kf-configuration-table.component.scss']
})
export class KfConfigurationTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['year', 'unuKeySetName', 'kfCategorySetName', 'collectionStreamName', 'launched', 'actions'];

  @Input()
  kfConfigurations!: KFConfiguration[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;
  @Input()
  schemaKind!: string;

  @Output()
  loadKfConfigurations: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  printKfConfiguration: EventEmitter<KFConfiguration> = new EventEmitter<KFConfiguration>();

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly router: Router,
              private kfConfigurationService: KfConfigurationService,
              private readonly dialog: MatDialog) {
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadKfConfigurations.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadKfConfigurations.emit({page: event.pageIndex, size: event.pageSize});
  }

  goToEdit(kfConfig: KFConfiguration): void {
    this.kfConfigurationService.existsKfRegistration(kfConfig.year, kfConfig.elementId, this.schemaKind)
      .subscribe(existsKfRegistration => {
        if (existsKfRegistration) {
          this.dialog.open(HelpDialogComponent,
            {
              data:
                {
                  title: 'Blocked Kf Configuration',
                  text: `Editing the KF Configuration is blocked, as the KF Registration data has already been saved. If you still need to change the configuration, contact the WF Admin to reopen it.`
                }
            });
        } else {
          this.router.navigate([`kfdataentry/${this.schemaKind.toLowerCase()}/kfconfiguration/` + kfConfig.year]).then(
            () => {
              // do nothing
            }
          );
        }
      });
  }

  print(kfConfig: KFConfiguration): void {
    this.printKfConfiguration.emit(kfConfig);
  }

  capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
  }
}
